// Phase I4 — shared empty/loading cards for all three Daily Acca
// directions. Copy is preserved from the existing Phase A
// DailyAccaPage so the abstaining message remains identical.

const fontMono = "var(--sa-font-mono)";
const fontBody = "var(--sa-font-body)";

const cardStyle: React.CSSProperties = {
  border: "1px solid var(--sa-hairline)",
  background: "var(--sa-bg-panel)",
  borderRadius: 8,
  padding: 28,
};

export function LoadingCard(): JSX.Element {
  return (
    <div style={cardStyle}>
      <div
        style={{
          fontFamily: fontMono,
          fontSize: 10.5,
          letterSpacing: "0.22em",
          color: "var(--sa-fg-muted)",
        }}
      >
        LOADING TODAY'S SURFACES…
      </div>
    </div>
  );
}

export function EmptyAccaCard(): JSX.Element {
  return (
    <div style={cardStyle}>
      <div
        style={{
          fontFamily: fontMono,
          fontSize: 10.5,
          letterSpacing: "0.22em",
          color: "var(--sa-fg-muted)",
        }}
      >
        DAILY ACCA · TODAY
      </div>
      <div
        style={{
          fontFamily: fontBody,
          fontSize: 14,
          color: "var(--sa-fg-secondary)",
          marginTop: 14,
          lineHeight: 1.7,
        }}
      >
        <p>
          Today's acca publishes once THE DESK's 18-agent dispatcher submits qualifying picks. If
          confidence isn't there, no slip — STRIKZA never publishes a fabricated tip.
        </p>
        <p style={{ color: "var(--sa-fg-muted)", marginTop: 10 }}>
          Check back at 11:00 GMT, or follow yesterday's result above.
        </p>
      </div>
    </div>
  );
}

export function EmptyFounderCard(): JSX.Element {
  return (
    <div style={{ ...cardStyle, marginTop: 32, border: "1px solid var(--sa-amber-dim)" }}>
      <div
        style={{
          fontFamily: fontMono,
          fontSize: 10.5,
          letterSpacing: "0.22em",
          color: "var(--sa-accent-saffron)",
        }}
      >
        FOUNDER'S PICK · TODAY
      </div>
      <div
        style={{
          fontFamily: fontBody,
          fontSize: 14,
          color: "var(--sa-fg-secondary)",
          marginTop: 14,
          lineHeight: 1.7,
        }}
      >
        <p>
          Founder's Pick mirrors the highest-conviction submission on THE DESK. If no agent
          submits at the conviction floor today, no pick — abstaining is honest.
        </p>
      </div>
    </div>
  );
}
